import React, { useRef, useState } from "react";
import { BiArea } from "react-icons/bi";
import { GiPathDistance } from "react-icons/gi";
import { GrPowerReset } from "react-icons/gr";
import { MdOutlineCompare, MdFileUpload, MdFileDownloadDone } from "react-icons/md";
import { PiSquareSplitHorizontalFill } from "react-icons/pi";
import { FaChartLine } from "react-icons/fa6";
import { VscGraphLine } from "react-icons/vsc";
import { MdDraw } from "react-icons/md";
import { MdOutlineMyLocation } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { axiosBaseInstance, mineData } from "../../data";
import DownloadSHP from "../DownloadSHP";
import SwitchDim from "../SwitchDim";
import styles from "./Toolbar.module.css"

const Toolbar = ({ startLineCal, startAreaCal, resetPolys, mapId, currentMapTypeIndex = '0', toggleDraw, exportGeoJson, saveToDb, removeDrawnPoly, coords, setCoords, drawPolygonFromPoints, segmentVolume, recenter, currMapData, startLineForElevation, fetchHeights, elevCoords, calculateVolumeWithinSegmet, layerIndicator, isCollapsed, setPointHeightActive, toolIndex, setToolIndex }) => {
  const navigate = useNavigate()
  const shpRef = useRef(null);
  const [shpFile, setShpFile] = useState(null)

  const handleOnShpChange = async (_event) => {
    const theSHP = _event.target.files[0];
    const formData = new FormData();
    formData.append("poly", theSHP);

    try {
      const resp = await axiosBaseInstance.post(`/uploadShp`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      const result = await resp.data;
      setCoords(result.coordinates)
      drawPolygonFromPoints(result.coordinates)
    } catch (error) {
      console.log(error.message);
    }
    if (shpRef.current) {
      shpRef.current.value = ""
    }

  }

  const currElvPath = mineData.find(el => el.id == mapId).elevationPath
  return (
    <div className={`animate_transit ${styles.toolbarContainer}`}>
      <nav
        className="navbar navbar-expand-lg navbar-light bg-dark-o rounded"
      // style={{
      //   position: "absolute",
      //   zIndex: 9999,
      //   top: "8%",
      //   right: "80%",
      //   padding: "5px",
      // }}
      >
        <div className="d-flex gap-4">

          <div className="btn-group">
            <button className="btn btn-dark btn-lg" title="Re-center" onClick={recenter} ><MdOutlineMyLocation /></button>
            {layerIndicator === 'volume' && <button className={`btn ${ toolIndex === 0 ? "btn-light" : "btn-dark"} btn-lg`} title="Start Area" onClick={() => {
              resetPolys() && startAreaCal();setToolIndex(prev=> prev===0 ? -1 : 0);
            }}
              ><BiArea size={20} /></button>}
            {layerIndicator === 'elevation' && <button className={`btn ${ toolIndex === 1 ? "btn-light" : "btn-dark"} btn-lg`} title="Start Distance" onClick={() => {
              resetPolys() && startLineCal();
              setToolIndex(prev=> prev===1 ? -1 : 1)
            }} ><GiPathDistance size={20} /></button>}
            <button className="btn btn-dark btn-lg" title="Reset" onClick={() => {
              resetPolys();
              setToolIndex(-1)
            }}><GrPowerReset size={20} /></button>
            {layerIndicator === 'elevation' && <button className={`btn ${ toolIndex === 2 ? "btn-light" : "btn-dark"} btn-lg`} title="Elevations" onClick={() => {startLineForElevation();setToolIndex(prev=> prev===2 ? -1 : 2)}}><VscGraphLine size={20} /></button>}
            {layerIndicator==='elevation'&&<button onClick={fetchHeights} disabled={elevCoords?.length < 2} style={{fontSize:8, fontWeight:"bold"}} className="btn btn-success btn-lg" title="Get Elevation" >LOAD</button>}
            {layerIndicator==='elevation'&&<button className={`btn ${ toolIndex === 3 ? "btn-light" : "btn-dark"} btn-lg`} onClick={() => {toggleDraw();setToolIndex(prev=> prev===3 ? -1 : 3)}}><MdDraw size={20} /></button>}
            {layerIndicator==='elevation'&&<button className={`btn ${ toolIndex === 4 ? "btn-light" : "btn-dark"} btn-lg`} onClick={() =>{ setPointHeightActive(prev=>!prev); setToolIndex(prev=> prev===4 ? -1 : 4)}} style={{fontSize:"12px"}}>PH</button>}
            
          </div>
          {/* <div className="btn-group">
            <button className="btn btn-dark btn-sm" onClick={saveToDb}>Save Drawings</button>
            <button className="btn btn-dark btn-sm" onClick={removeDrawnPoly}>remove</button>
          </div> */}
        </div>

      </nav>
      <nav className="navbar navbar-expand-lg navbar-light bg-dark-o rounded"
      // style={{
      //   position: "absolute",
      //   zIndex: 9999,
      //   top: "40%",
      //   right: "80%",
      //   padding: "5px",
      // }}
      >
        <div className="d-flex gap-4">
          <div className="btn-group">
            {
              segmentVolume &&
              <>
                <button className="btn btn-dark btn-lg" title="Upload coordinates(shp)" onClick={() => shpRef.current.click()} ><MdFileUpload size={20} /></button>
                <input type="file" ref={shpRef} onChange={handleOnShpChange} style={{ display: "none" }} />
                <DownloadSHP coords={coords} />
              </>
            }
            {layerIndicator === 'volume' && <SwitchDim currMapData={currMapData} currentMapTypeIndex={currentMapTypeIndex} />}

            {layerIndicator==='elevation'&&<button className="btn btn-dark btn-lg" title="Compare Elevation Visits" onClick={() => navigate('/dashboard/cmaps/' + mapId)}><MdOutlineCompare size={20} /></button>}
            {layerIndicator === 'volume' && <button className="btn btn-dark btn-lg" title="Compare Segment Visits" onClick={() => navigate('/dashboard/csegments/' + mapId)}><PiSquareSplitHorizontalFill size={20} /></button>}
            {coords.length >= 3 && <button
              className="btn btn-dark btn-sm"
              disabled={coords.length < 3}
              // onClick={() => openModal("calculate")}
              onClick={() => calculateVolumeWithinSegmet()}
            >
              <MdFileDownloadDone size={20} />
            </button>}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Toolbar;
